export default __webpack_public_path__ + "static/media/warehouse2.8d120597.svg";